import React from 'react';
import { observer } from 'mobx-react-lite';
import { BlogPostPreview as RawBlogPostPreview } from '../../../components/landingPage/BlogPostPreview';
import { imageUrl } from '../../../lib/landingPage';
import { Wrapper } from '../Wrapper';
import { readingTime } from '../BlogPost/formatters';
import { SanityBlogPostPreview } from '../BlogPost/types';
import { DateTime } from 'luxon';

export const BlogPostPreview = observer(
    Wrapper((post: SanityBlogPostPreview) => {
        return (
            <RawBlogPostPreview
                url={post.url}
                title={post.title}
                category={post.category.title}
                color={post.category.color}
                creationDate={DateTime.fromISO(
                    post.dateOfWriting || post._createdAt
                )}
                image={imageUrl(post.imageRef.image, 'blog').quality(100).url()}
                readingTime={readingTime(post)}
            />
        );
    }, 'post')
);
